import { SupportedLanguages } from "../../../libs/i18next/language";
import { FirebaseData } from "../General/FirebaseData";
import { TranslationData } from "../General/TranslationData";
import { TenantTypeID } from "../Property/Units/TenantType";

export class CompanyTaskTypeData extends FirebaseData {
  title: TranslationData = new TranslationData();

  enabledFor?: {
    roles: number[];
    tenantTypes: TenantTypeID[];
  };

  setup(data: any) {
    this.title.setup(data.title, SupportedLanguages.EN);

    if (typeof data.enabledFor === "object" && data.enabledFor !== null) {
      this.enabledFor = {
        roles: Array.isArray(data.enabledFor?.roles) ? data.enabledFor.roles : [],
        tenantTypes: Array.isArray(data.enabledFor?.tenantTypes) ? data.enabledFor.tenantTypes : [],
      };
    } else {
      this.enabledFor = undefined;
    }

    super.setup(data);
  }
}

